/**
 * @file Composable for managing the action menu anchor state on auth pages.
 */

import { getAnchorFromElement } from '@@/library/v4/components/OzPopoverModal.anchor'
import type { PopoverAnchor } from '@@/types'
import { ref } from 'vue'

function useActionMenuAnchor() {
  const actionMenuAnchor = ref<Partial<PopoverAnchor> | null>(null)

  const openActionMenu = (event: Event): void => {
    actionMenuAnchor.value = {
      ...getAnchorFromElement(event.currentTarget as Element),
      position: 'bottom',
    }
  }

  const closeActionMenu = (): void => {
    actionMenuAnchor.value = null
  }

  return { actionMenuAnchor, openActionMenu, closeActionMenu }
}

export { useActionMenuAnchor }
